import { caAtom, caCheckAtom } from '@/atoms/caCheck';
import { rugWalletAtom } from '@/atoms/rugWallet';
import { tokenInfoAtom } from '@/atoms/tokenInfo';
import { xAtom } from '@/atoms/xAtom';
import { useSetAtom } from 'jotai';

export const useResetSearch = () => {
  const setCA = useSetAtom(caAtom);
  const setCheckCAResult = useSetAtom(caCheckAtom);
  const setTokenInfoResult = useSetAtom(tokenInfoAtom);
  const setXInfoResult = useSetAtom(xAtom);
  const setRugWalletResult = useSetAtom(rugWalletAtom);

  const handleReset = () => {
    setCA('');
    setCheckCAResult(undefined);
    setTokenInfoResult(undefined);
    setXInfoResult(undefined);
    setRugWalletResult(undefined);
    window.history.pushState(null, '', '/');
  };

  const resetSearch = () => {
    setCA('');
    setCheckCAResult(undefined);
    setTokenInfoResult(undefined);
    setXInfoResult(undefined);
    setRugWalletResult(undefined);
  };

  return { handleReset, resetSearch };
};
